package org.hs_soft.runmynesto.domain.usecase.options.price_category

import org.hs_soft.runmynesto.domain.model.home.options.price_category.PriceCategoryModel
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_options.PriceLevelModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.price_category.UpdatePricesCategoryRepository


class UpdatePriceCategoriesUseCase
    (private val repository: UpdatePricesCategoryRepository) {
    suspend operator fun invoke(prices:List<String?>): PriceLevelModel {
        return repository.updatePriceCategory(prices)
    }
}